<template>
	<section class="container">
        <div class="table-container">
            <el-col :span="24" class="page-bar">
                <div class="total-results"> {{totalResult}} </div>
            </el-col>
            <el-table :data="list" v-loading="listLoading"
                    style="width:100%;" empty-text="暫無資料"
                    @row-click="rowClick" >
                <el-table-column min-width="15%" prop="date" label="申請日期" :formatter="formatDate">
                </el-table-column>
                <el-table-column min-width="15%" prop="name" label="申請人"> 
                </el-table-column>
                <el-table-column min-width="15%" prop="id" label="工號"> 
                </el-table-column>
                <el-table-column min-width="20%" prop="dep" label="部門">
                </el-table-column>
                <el-table-column min-width="15%" prop="level" label="師級" :formatter="formatLevel">
                </el-table-column>
                <el-table-column min-width="20%" prop="email" label="信箱">
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="註冊審核" :visible.sync="dialogFormVisible" custom-class="regApprovalDialog">
            <div class="dialogRow">
                <div class="dialogCell1">申請人</div>
                <div class="dialogCell2"> {{ dialogData.name }} </div>
            </div>
            <div class="divider"></div>
            <div class="dialogRow">
                <div class="dialogCell1">工號</div>
                <div class="dialogCell2"> {{ dialogData.id }} </div>
            </div>
            <div class="divider"></div>
            <div class="dialogRow">
                <div class="dialogCell1">部門</div>
                <div class="dialogCell2"> {{ dialogData.dep }} </div>
            </div>
            <div class="divider"></div>
            <div class="dialogRow">
                <div class="dialogCell1">信箱</div>
                <div class="dialogCell2"> {{ dialogData.email }} </div>
            </div>
            <div class="divider"></div>
            <div class="dialogRow">
                <div class="dialogCell1">師級</div>
                <div class="dialogCell2"> {{ formatLevel(dialogData) }} </div>
            </div>
            <div slot="footer">
                <el-button class="rejectBtn" @click="regApproval(0)">拒絕</el-button>
                <el-button class="ApprovalBtn" @click="regApproval(1)">通過</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import API from '@/api/api';
import util from '@/common/js/util';
import { DepartmentModel } from '@/common/js/data';
export default {
    name: 'RegApproval',
    data() {
      return {
        departmentModel : null,
        list: [],
        totalResult: '',
        total: 0,
        listLoading: false,
        dialogFormVisible: false,
        dialogData: {},
      };
    },
    watch: {
        '$store.state.userInfoReady': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.init();
                }
            }
        }
    },
    methods: {
        init() {
            this.departmentModel = new DepartmentModel();
            this.reload();
        },
        async reload() {
            let dep = this.$store.state.isSystemAdminMode ? null : this.$store.state.userActualDepId;
            this.listLoading = true;
            API.getRegisterList(dep).then(async (response) => {
                if(response.status) {
                    if(!JSON.parse(response.request.response).error_msg) {
                        this.$message.error('取得註冊列表發生錯誤');
                    } else {
                        this.$message.error(JSON.parse(response.request.response).error_msg);
                    }
                } else {
                    let regList = response.filter(x => x.status === null);
                    this.total = regList.length;
                    this.list.splice(0);
                    for (let i = 0 ; i < this.total ; i++) {
                        let obj = {};
                        obj.date = regList[i].date * 1000;
                        obj.name = regList[i].displayname;
                        obj.id = regList[i].name;
                        obj.dep = await this.departmentModel.getDepName(regList[i].actual_depid);
                        obj.level = regList[i].level;
                        obj.email =  regList[i].email;
                        this.list.push(obj);
                    }
                    this.updateTotalResult();
                    if (regList.length > 0) {
                        this.$store.state.regDot = true;
                    } else {
                        this.$store.state.regDot = false;
                    }
                    this.listLoading = false;
                }
            });
        },
        updateTotalResult() {
            this.totalResult = ' 共 ' + this.total + ' 筆註冊';
        },
        formatDate(row) {
            return util.formatDate.format(new Date(row.date), 'yyyy-MM-dd');
        },
        formatLevel: function (row) {
            if (row.level === 1) {
                return '師2-師5';
            } else if (row.level === 2) {
                return '師6-師11';
            } else if (row.level === 3) {
                return '師12以上';
            }

            return '';
        },
        rowClick: function(row) {
            this.dialogData = row;
            this.dialogFormVisible = true;
        },
        regApproval(status) {
            this.listLoading = true;
            API.registerApproval(this.dialogData.id, status, this.dialogData.email).then((response) => {
                if(response.status) {
                    if(!JSON.parse(response.request.response).error_msg) {
                        this.$message.error('審核註冊發生錯誤');
                    } else {
                        this.$message.error(JSON.parse(response.request.response).error_msg);
                    }
                } else {
                    this.$message({
                        message: '審核完成',
                        type: 'success'
                    });
                    this.dialogFormVisible = false;
                    this.reload();
                }
            });
        },
     },
    created() {
        this.$store.state.nowStatus = 15;
    },
  }
</script>
<style lang="scss">
    .regApprovalDialog {
        width: 350px;
    }
</style>
<style lang="scss" scoped>
    .container {
        overflow-y: auto;
        background-color: #F5F8FA;
        
        .table-container {
            width: 90%;
            margin: 30px auto 80px;
        }

        .el-dialog--small {
            width: 350px;
        }

        .dialogRow {
            height: 50px;
            font-size: 16px;
            line-height:50px;
            color: #515151;

            .dialogCell1 {
                width: 100px;
                display: inline-block;
            }

            .dialogCell2 {
                display: inline-block;
            }
        }

        .divider {
            height: 1px;
            width: 90%;
            border: 1px solid #EEEEEE;
        }

        .rejectBtn {
            width: 76px;
            border-radius: 2px;
            color: #FFFFFF;
            background-color: #CD5454;
            border-color: #CD5454;
        }

        .ApprovalBtn {
            width: 76px;
            border-radius: 2px;
            color: #FFFFFF;
            background-color: #31A30D;
            border-color: #31A30D;
        }
    }
</style>


// WEBPACK FOOTER //
// RegApproval.vue?3f706b1f